<template>
    <div>
      <Button
        :size="15"
        color="#33BDFF"
        colorText="#ffffff"
        tooltip="Reemplazar"
        icon="fas fa-exchange-alt"
        round
        :width="30"
        class="mt-2 mb-3 mr-2"
        translate
        @click.native="showModalValidation();"
      />
      <ui-modal
        ref="modal"
        size="small"
        class="modal-buscar-reemplazar-acuerdos-lineas"
        title="Buscar y Reemplazar"
        @close=" ActionSetZindexTablaModal(false);"
      >
        <!-- Cuerpo -->
        <div>
          <!-- Campo en donde buscar -->
          <div class="d-flex">
            <ui-select
              label="Campo en donde Buscar :"
              class="w-100 mr-2 mt-3"
              :keys="{ value: 'id', label: 'name' }"
              placeholder="Seleccione"
              :options="listaCampos"
              @change="changeFormatField();"
              v-model="dataCampoParaBuscar"
            ></ui-select>
          </div>
          <!-- Valor a buscar  -->
          <div v-if="dataCampoParaBuscar.id === undefined   || dataCampoParaBuscar.id === 'margin' " >
            <ui-textbox
              label="Valor a Buscar :"
              class="w-100 mt-3"
              v-mask="marginMask"
              v-model="dataValorCampo"
            ></ui-textbox>
          </div>

          <div v-if=" dataCampoParaBuscar.id === 'container_id' " >
            <ui-select
              class="w-100 ml-2"
              has-search
              label="Tipo contenedor"
              placeholder="Seleccionar"
              searchPlaceholder="Buscar"
              :keys="{ value: 'id', label: 'code'  }"
              v-model="dataValorCampo"
              :options="containers"
            />
          </div>
  
          <div v-if="dataCampoParaBuscar.id === 'from_date' || dataCampoParaBuscar.id === 'to_date' || dataCampoParaBuscar.id === 'vigency' " >
          
            <date-picker
              class="w-100 datepicker-custom mt-4"
              placeholder="Valor a Buscar :"
              type="date"
              value-type="format"
              @close="handleOpenChange"
              v-model="dataValorCampo"
            />
          </div> 

        </div>
        <!-- Valor a Reemplazar -->
        <div v-if="dataCampoParaBuscar.id === undefined || dataCampoParaBuscar.id === 'margin'">
          <ui-textbox
            label="Valor a Reemplazar :"
            class="w-100 mt-3"
            v-mask="marginMask"
            v-model="dataValorReemplazar"
          />
        </div>
  
        <div v-if=" dataCampoParaBuscar.id === 'container_id' " >
          <ui-select
            class="w-100 ml-2"
            has-search
            label="Tipo contenedor"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :keys="{ value: 'id', label: 'code'  }"
            v-model="dataValorReemplazar"
            :options="containers"
          />
        </div>

        <div v-if="dataCampoParaBuscar.id === 'from_date' || dataCampoParaBuscar.id === 'to_date' || dataCampoParaBuscar.id === 'vigency'">
          <date-picker
            class="w-100 datepicker-custom mt-5"
            placeholder="Valor a Reemplazar :"
            type="date"
            value-type="format"
            @close="handleOpenChange"
            v-model="dataValorReemplazar"
          />
        </div> 
  
        <!-- Footer -->
        <div class="d-flex justify-content-between mt-3">
          <button class="btn btn-default" @click="closeModal('modal')">
            Cerrar
          </button>
          <button
            class="btn btn-outline-success"
            id="buttonRef11"
            @click="filtrarDatos"
          >
            Buscar y Reemplazar
          </button>
        </div>
      </ui-modal>
    </div>
  </template>
  
  <script>
  // Vue
  import Vue from "vue";
  // Vuex
  import { mapActions, mapState } from "vuex";
  // Toast
  import VueToastify from "vue-toastify";
  import UiTextbox from "keen-ui/src/UiTextbox";
  import UiSelect from "keen-ui/src/UiSelect";
  import createNumberMask from "text-mask-addons/dist/createNumberMask";
  
  import DatePicker from "vue2-datepicker";
  import "vue2-datepicker/locale/es";
  import "vue2-datepicker/index.css";
  Vue.use(VueToastify);
  
  // UI Modal
  import UiModal from "keen-ui/src/UiModal";
  
  // Constantes
  import {buscarYReemplazarClientesBaseCount,buscarYReemplazarClientesBase,getAcuerdosClientesBase } from  "../../../../../constants/lineas" ;
  // Buttom
  import Button from "../../../../common/Button";

  const marginMask = createNumberMask({
    prefix: "",
    suffix: "",
    allowDecimal: true,
    requireDecimal: false,
    includeThousandsSeparator: false,
    decimalSymbol: ".",
    decimalLimit: 2,
    integerLimit: 6,
    allowNegative: true
  });
  
  export default {
    props: ["addAcuerdoLineasForm","data","getListaAcuerdosClientesBase", "showBuscarReemplazar","dataInicial"],
    data() {
      return {
        marginMask,
        dataCampoParaBuscar: "",
        dataValorCampo: "",
        dataValorReemplazar: "",
        containers: [],
        listaCampos: [
          {
            id: "from_date",
            name: "Desde",
          },
          {
            id: "to_date",
            name: "Hasta",
          },
          {
            id: "margin",
            name: "Margen",
          },
          {
            id: "vigency",
            name: "Vigencia",
          },
          {
            id: "container_id",
            name: "Unidad",
          },
        ],
      };
    },
    components: {
      UiModal,
      Button,
      DatePicker,
      UiTextbox,
      UiSelect
    },
    computed: {
      ...mapState([
        "contenedores",
        "atmosferas",
        "puertos",
        "showAcuerdoLineasClienteBase"
      ]),
      ...mapState("lineas", [
        "dataListaProducto"
      ]),
      
    },
    methods: {
      ...mapActions(["ActionSetZindexModal", 'ActionSetZindexTablaModal', 'ActionSetZindexModal']),
      ...mapActions(["AccionCambiar", "ActionSetLoadingTable","ActionSetClientes","ActionSetNavieras","ActionSetAtmosferas",
                  "ActionSetContenedores","ActionSetCommodity","ActionSetContratos"]),
      ...mapActions("lineas", ["actionSetDataListarTarifasAcuerdosClientesBase"]),
      ...mapActions(["ActionSetShowAcuerdoLineasClienteBase"]),

      changeFormatField( ) {
          this.dataValorCampo = "" ;
          this.dataValorReemplazar = "" ;
      },
      showModalValidation(){
        this.showAcuerdoLineasClienteBase
        ? this.openModal('modal')
        : this.$vToastify.warning(
          "Se deben filtrar datos para poder reemplazar.",
          "!Precaución¡"
        );
      },
      handleOpenChange() {
          this.showTimePanel = false;
      },
      openModal(ref) {
        this.$refs[ref].open();
      },
      closeModal(ref) {
          this.$refs[ref].close();
      },
      estadoButton(text, estado = true) {
          let buttonRef = document.querySelector("#buttonRef11");
          buttonRef.innerHTML = text;
          buttonRef.disabled = estado;
      },
      cerrarModal() {
          this.ActionSetZindexModal(false);
      },
      async filtrarDatos() {
  
        if( this.data.length === 0 )  return this.$vToastify.warning(
          "No hay datos para reemplazar.",
          "Precaución"
        ); 

        if( this.dataCampoParaBuscar.id === undefined || this.dataCampoParaBuscar.id === ""  ) return this.$vToastify.error(
          "Campo en donde Buscar no debe quedar vacío.",
          "¡Error!"
        );

        if( this.dataValorCampo === undefined || this.dataValorCampo === ""  ) return this.$vToastify.error(
          "Campo Valor a Buscar no debe quedar vacío.", "¡Error!"
        );

        if( this.dataValorReemplazar === undefined || this.dataValorReemplazar === "" ) return this.$vToastify.error(
          "Campo Valor a reemplazar no debe quedar vacío.", "¡Error!"
        );
        
        const ids = this.data.map( d => d.data_complementaria.id ) ;

        const form = {
          ids,
          field : this.dataCampoParaBuscar.id,
          valorABuscar :  (typeof this.dataValorCampo) === "object" ? this.dataValorCampo.id : this.dataValorCampo,
          valorAReemplazar: (typeof this.dataValorReemplazar) === "object" ? this.dataValorReemplazar.id : this.dataValorReemplazar 
        } ;  
        
        this.estadoButton("Realizando Solicitud...");

        try {
          this.$vToastify.loader("Realizando Solicitud...");
  
          const { data } = await buscarYReemplazarClientesBaseCount( form ) ;
          this.$vToastify.stopLoader();
  
          if( data.cantidad === 0 ){
            this.estadoButton("Buscar y Reemplazar", false);

            return this.$vToastify.error(
              "No se encontraron registros con los datos ingresados.",
              "¡Error!"
            );
          } else {
            const response = await this.$vToastify.prompt({
              body: `¡Advertencia! \n  ¿Estás seguro que deseas modificar ${data.cantidad} registros?`,
              answers: { Sí: true, No: false },
            });

            if( !response ) return this.estadoButton("Buscar y Reemplazar", false);
          }

        } catch (error) {
          this.estadoButton("Buscar y Reemplazar", false);
          this.$vToastify.stopLoader();
          return ;
        }
        
        try {
          this.$vToastify.loader("Realizando Solicitud...");
  
          await buscarYReemplazarClientesBase( form ) ;
          
          this.ActionSetLoadingTable(true);

          const { data_table, filtros_clientes, filtros_atmosferas,
              filtros_contenedor, filtros_contratos,filtros_navieras,filtros_productos 
          } = await getAcuerdosClientesBase();

          this.actionSetDataListarTarifasAcuerdosClientesBase( data_table );

          this.ActionSetClientes( filtros_clientes );
          this.ActionSetNavieras( filtros_navieras );
          this.ActionSetAtmosferas(filtros_atmosferas);
          this.ActionSetContenedores(filtros_contenedor);
          this.ActionSetCommodity( filtros_productos );
          this.ActionSetContratos( filtros_contratos );

          this.dataCampoParaBuscar = "" ;
          this.dataValorCampo = "" ;
          this.dataValorReemplazar = "" ;
  
          this.$vToastify.stopLoader();
          this.$vToastify.success("Se han reemplazado datos con éxito.", "Realizado");
  
          this.estadoButton("Buscar y Reemplazar", false);
          this.closeModal('modal');
        
        } catch (error) {
          this.$vToastify.error(
              "Hubo un error al actualizar datos, recargue e intente nuevamente.",
              "¡Error!"
          );
          this.estadoButton("Buscar y Reemplazar", false);
          this.$vToastify.stopLoader();
        }
      },
      getContainers(){
        const { lista_contenedores } = JSON.parse( localStorage.getItem('datComplex') );
        this.containers = lista_contenedores;
      }
    },
    mounted(){
      this.getContainers();
    }
  };
  </script>
  
  <style>
    .modal-buscar-reemplazar-acuerdos-lineas {
      /* background-color: aqua; */
      z-index: 20 !important;
    }
  .mx-datepicker{
    margin-left: 0px ;
  }
  </style>
  
